import * as React from "react"
import Layout from "../components/layout"
import Seo from '../components/seo'
import { navigate } from "gatsby"
import {
  button
} from '../components/layout.module.css'

const IndexPage = () => {
  return (
    <Layout pageTitle="Thank you for visiting">
      <main>
        
        <p>
          GEBL is consistently on the lookout for those that want to learn homebrewing and meet monthly with other beer lovers. Our club meets in Lake Stevens at <a href="https://www.sound2summit.com/" target="new">Sound2Summit Brewing</a> the second Monday of the month. Be sure to bring some homebrew for sharing with the club.
        </p>
        <p>
          The purpose of The Greater Everett Brewers League is to promote and educate homebrewers in the production of craft-style homebrewed beers. As an AHA social club, we improve members’ brewing skills by providing mentoring and networking to fellow brewers, promoting BJCP judging, providing evaluation and competition entry information, as well as promoting the local craft beer movement.
        </p>
        
        <div align="center">
        <button className={button} onClick={()=>{navigate("/calendar")}}>Club Calendar</button>     <button className={button} onClick={()=>{navigate("/about")}}>About GEBL</button>
        </div>

        <br />
        <hr></hr>
        <h2><a href="/news">Club News</a></h2>
        <p>
          Check the news and review past meeting notes. Be sure to check the calendar for the upcoming meetings. This is a good place to review past meetings and find links to upcoming events sponsored by the GEBL club.
        </p>

        <br />
        <hr></hr>
        <h2><a href="/news">Upcoming Meetings</a></h2>
        <p>
          Check the news and review past meeting notes. Be sure to check the calendar for the upcoming meetings. This is a good place to review past meetings and find links to upcoming events sponsored by the GEBL club.
        </p>

        <p align="center">
          <iframe title="GEBL Short Calendar" src="https://calendar.google.com/calendar/embed?height=300&wkst=1&bgcolor=%23ffffff&ctz=America%2FLos_Angeles&mode=AGENDA&title=GEBL%20Club%20Calendar&showNav=0&showPrint=0&showTabs=0&showCalendars=1&src=Z2VibHByZXNpZGVudEBnbWFpbC5jb20&color=%23F4511E" width="500" height="300" frameborder="0"></iframe>
        </p>

        <br />
        <hr></hr>
        <h2><a href="/recipes">Latest Recipes</a></h2>

        <table>
          <tr>
            <td>
                <span><a href="./recipes/czeck-dark-lager-same-brew" aria-label="Czeck Dark Lager">Czech Dark Lager</a></span>
            </td>
            <td>
                <span>Posted April 11, 2024</span>
            </td>
            <td>
                <span>Brewed for May 2024 Club Meeting</span>
            </td>
          </tr>
          <tr>
            <td>
                <span><a href="./recipes/grisette" aria-label="Grisette">Grisette</a></span>
            </td>
            <td>
                <span>Posted April 11, 2023</span>
            </td>
            <td>
                <span>Provided by Ray and Vicki Garcia. Style: Saison 25B</span>
            </td>
          </tr>
          <tr>
            <td>
            <span><a href="./recipes/pale-ale-same-recipe" aria-label="Pale Ale Same Recipe">Pale Ale Same Recipe with Different Hops</a></span>
            </td>
            <td>
                <span>Posted February 27, 2023</span>
            </td>
            <td>
                <span>Pale Ale Same Recipe</span>
            </td>
          </tr>
        </table>

        <br />
        <hr></hr>
        <h2><a href="/media">Social Media Connections</a></h2>
        <p>Including guest speakers and club collaboration videos. Be sure to like our <a href="https://www.youtube.com/@greatereverettbrewersleagu8128">Youtube channel</a> and follow us on social media to stay in the know!</p>
        
      </main>
    </Layout>
  )
}

export default IndexPage

export const Head = () => <Seo title="GEBL Home" />
